module.exports = __webpack_public_path__ + "img/wine.991bb200.png";